import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import DediAsinMain from './components/DediAsinMain';
import './dediasin.css';

const DediAsinPage = () => {
  usePageMeta({
    title: 'DediAsin（デディアシン）| シフト希望・配置・稼働をひとつに | 株式会社MSK',
    ogTitle: 'DediAsin（デディアシン）| シフト希望・配置・稼働をひとつに | 株式会社MSK',
    description:
      'シフト管理サービスと表計算に分かれていた希望・配置・稼働時間・連絡を、一つの画面にまとめるシフト管理「DediAsin」。ボタンひとつで配置の下地を置き、人別と勤務先別の両方で確認できます。貴社の体制に合わせて調整してご提供します。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <DediAsinMain />
      <Footer />
    </div>
  );
};

export default DediAsinPage;
